var render = function render(){var _vm=this,_c=_vm._self._c;return _c('go-edit-table',{attrs:{"height":_vm.height,"dataSource":_vm.detailList,"edit":false,"showCheck":false,"columns":_vm.columns,"pagination":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }